import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { getDefaultStore } from 'jotai'
import { authApi } from '@/api/auth.api'
import type { LoginRequest } from '@/api/auth.api'
import { isInitializedAtom, sessionAtom } from '@/store/auth.atom'
import { notification } from 'antd'

interface UseLoginOptions {
    redirectTo?: string
}

export function useLogin({ redirectTo = '/dashboards' }: UseLoginOptions = {}) {
    const navigate = useNavigate()

    return useMutation({
        mutationFn: (payload: LoginRequest) => authApi.login(payload),
        onSuccess: async (session) => {
            const store = getDefaultStore()
            if (session.user.loginCount === 0) {
                store.set(sessionAtom, session)
                navigate({ to: '/password' })
                store.set(isInitializedAtom, true)
                notification.success({
                    title: session.responseMessage
                })
                return
            }
            if (session.permissions.length === 0) {
                throw new Error('Người dùng chưa có quyền truy cập vào hệ thống. Vui lòng liên hệ quản trị viên để được cấp quyền.')
            }

            const finalSession = {
                ...session,
                permissions: session.permissions,
            }
            store.set(sessionAtom, finalSession)
            notification.success({
                title: session.responseMessage,
            })

            store.set(isInitializedAtom, true)
            const safeRedirect = redirectTo || '/dashboards'
            navigate({ to: safeRedirect })
        },
    })
}

